/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryExtraKeyValue extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryExtraKeyValue");
    }

    getFixupPrototypeFunction() { return ResourceQueryExtraKeyValue.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryExtraKeyValue>): ResourceQueryExtraKeyValue {
        let obj = Object.assign(new ResourceQueryExtraKeyValue(), model);
        ResourceQueryExtraKeyValue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryExtraKeyValue>): ResourceQueryExtraKeyValue {
        if (!model) return null;
        return ResourceQueryExtraKeyValue.newInstance(<ResourceQueryExtraKeyValue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryExtraKeyValue) {
        if (!obj) return;

        models.ResourceQueryExtraKeyValue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryExtraKeyValue): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryExtraKeyValue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Extra key for the given resources
     */
    extra_key: string;

    /**
     * Extra values for the given key
     */
    extra_values: Array<string>;

}
